import { fromJS } from 'immutable';

// eslint-disable-next-line import/prefer-default-export
export const handleSetPassengers = (state, passengers) => {
  return state.merge({
    savingPassengers: false,
    passengers: fromJS(passengers),
  });
};
